export enum ServiceTypeEnum{
    telephone = 1,
    link = 2,
    telemedicine = 3,
}